import React from 'react';

export const SSRDataContext = React.createContext(null);
